<h5 class="h5 sidebar__section-title">
  {{ 'sharedModule.bkgSummaryReservation.data' | translate }}
</h5>
<div class="sidebar__content">
  <div class="sidebar__content-item">
    <strong>
      {{ 'sharedModule.bkgSummaryReservation.name' | translate }}
    </strong>
    {{ reservation?.trip?.driver }}
  </div>
  <div class="sidebar__content-item">
    <strong>
      {{ 'sharedModule.bkgSummaryReservation.email' | translate }}
    </strong>
    {{ reservation?.trip?.email }}
  </div>
  <div class="sidebar__content-item" *ngIf="reservation?.trip?.vehicle?.plate">
    <strong>
      {{ 'sharedModule.bkgSummaryReservation.plate' | translate }}
    </strong>
    {{ reservation?.trip?.vehicle?.plate }}
  </div>
  <div *ngIf="reservation?.trip?.flightNumber" class="sidebar__content-item">
    <strong>
      {{ 'sharedModule.bkgSummaryReservation.flightNumber' | translate }}
    </strong>
    {{ reservation?.trip?.flightNumber }}
  </div>
  <div *ngIf="reservation?.id_invoice_profile" class="sidebar__content-item">
    <strong>
      {{ 'sharedModule.bkgSummaryReservation.billingProfile' | translate }}
    </strong>
    <br />
    {{ profile[0].invoice_name }}
    <br />
    {{ profile[0].invoice_nif }}
    <br />
    {{ profile[0].invoice_address }}
    <br />
    {{ profile[0].invoice_city }} {{ profile[0].invoice_zip }}
    <br />
    {{ profile[0].invoice_state }} {{ profile[0].invoice_country }}
  </div>
</div>
